var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Choose Report "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c("li", [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.gstPeriod != 0,
                          expression: "gstPeriod!=0",
                        },
                      ],
                      staticClass: "select is-fullwidth",
                    },
                    [
                      _vm.options
                        ? _c("Multiselect", {
                            attrs: {
                              options: _vm.options,
                              placeholder: "Select a month",
                              label: "month",
                              "show-labels": false,
                            },
                            on: { select: _vm.selectMonth },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tag is-pulled-right is-success",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.year) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(`${props.option.month}`)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4008292251
                            ),
                            model: {
                              value: _vm.selectedMonth,
                              callback: function ($$v) {
                                _vm.selectedMonth = $$v
                              },
                              expression: "selectedMonth",
                            },
                          })
                        : _vm._e(),
                      _vm.selectedMonth
                        ? _c("span", { staticClass: "help is-success" }, [
                            _vm._v(
                              "GST Period: " +
                                _vm._s(_vm.selectedMonth.firstDay) +
                                " To: " +
                                _vm._s(_vm.selectedMonth.lastDay)
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("hr"),
          _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.withHolding },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-file-document mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("With-Holding")]),
                ]
              ),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.rePrint },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-file-document mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Reprint")]),
                ]
              ),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  attrs: { disabled: !_vm.selectedMonth },
                  on: { click: _vm.print },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-file-document mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Print")]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }